import { FormikOnSubmit } from 'lib/formik.utils';
import React, { useCallback } from 'react';
import { forgetPassword } from 'api/AccessAPI';
import { useMutation } from 'react-query';
import { message } from 'antd';
import { WrappedLanguageControl } from 'common/organisms/WrappedLanguageControl';
import { PublicContainer } from 'common/components/PublicContainer';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { ForgetPasswordForm } from 'pages/ForgetPassword/ForgetPasswordForm';

export interface ForgetPasswordFormModel {
  email: string;
}

export interface ForgetPasswordFormProps {
  loading: boolean;
  onSubmit: FormikOnSubmit<ForgetPasswordFormModel>;
}

export const ForgetPasswordPage: React.FC = () => {
  const [mutate, { isLoading }] = useMutation(forgetPassword);
  const intlMessage = useFormatMessage();

  const handleSubmit: FormikOnSubmit<ForgetPasswordFormModel> = useCallback(
    (formData) => {
      console.log(formData.email);
      mutate(
        { email: formData.email },
        {
          onSuccess: () => {
            formData.email !== ''
              ? message.success(
                  intlMessage({
                    id: 'authentication.requestResetPasswordSuccessMessage',
                  })
                )
              : message.warning(
                  intlMessage({
                    id: 'authentication.resetPasswordDescription',
                  })
                );
          },
        }
      ).then();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mutate]
  );

  return (
    <PublicContainer>
      <WrappedLanguageControl />
      <ForgetPasswordForm onSubmit={handleSubmit} loading={isLoading} />
    </PublicContainer>
  );
};
